import styled from "styled-components";
import { Button } from "components/bootstrap";
export const ActionButtonStyled = styled(Button)`
  border-radius: 4px;
  min-width: 130px;
`;
